import { IApiResponse } from "../../../@types/api-response.type"
import { IKeyValue } from "../../../@types/key-value.type"
import { IProjectStatus } from "../../../@types/project/project-status.type"
import { Api } from "../ApiConfig"

const getAllProjectStatusIdsAndNames = async (): Promise<IKeyValue[]> => {
    const { data } = await Api.get<IApiResponse<IKeyValue[]>>(`/api/ProjectStatus/GetAllProjectStatusIdsAndNames`)
    return data.result
}

const getAllProjectStatus = async (): Promise<IProjectStatus[]> => {
    const { data } = await Api.get<IApiResponse<IProjectStatus[]>>(`/api/ProjectStatus/GetAllProjectStatus`)
    return data.result
}

const getProjectStatusById = async (id: string): Promise<IProjectStatus> => {
    const { data } = await Api.get<IApiResponse<IProjectStatus>>(`/api/ProjectStatus/GetProjectStatusById?id=${id}`)
    return data.result
}

const addOrUpdateProjectStatus = async (projectStatus: IProjectStatus): Promise<void> => {
    await Api.post<void>(`/api/ProjectStatus/AddOrUpdateProjectStatus`, projectStatus)
}

const deleteProjectStatus = async (id: string): Promise<void> => {
    await Api.delete<void>(`/api/ProjectStatus/DeleteProjectStatus/${id}`)
}

const reorderProjectStatus = async (reorderItems: IKeyValue[]): Promise<void> => {
    await Api.post<void>(`/api/ProjectStatus/ReorderProjectStatus`, reorderItems)
}

export const ProjectStatusService = {
    getAllProjectStatusIdsAndNames,
    getAllProjectStatus,
    getProjectStatusById,
    addOrUpdateProjectStatus,
    deleteProjectStatus,
    reorderProjectStatus
}